// extracted by mini-css-extract-plugin
module.exports = {"contactInfoHeader":"Contact_contactInfoHeader__3kVpi","socialLogo":"Contact_socialLogo__2T9IG"};